import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import "./Layout.css";

const Layout = () => {
  return (
    <>
      <Navbar />
      <main className="app-container">
        <Outlet />
      </main>
      {/* footer */}
      <Footer />
    </>
  );
};

export default Layout;
